// import React, { useState } from "react";
// import { Form, Input, Button, Upload, message } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import { Editor } from "@tinymce/tinymce-react";
// import courseService from "../../services/course.service"; // Ton service API

// const TrainingForm = ({ courseId }) => {
//   const [file, setFile] = useState(null);
//   const [editorContent, setEditorContent] = useState("");

//   const handleSubmit = async (values) => {
//     try {
//       if (!file) {
//         message.warning("Veuillez sélectionner un fichier.");
//         return;
//       }

//       await courseService.uploadTrainingExercise(
//         courseId,
//         file,
//         values.title,
//         editorContent
//       );

//       message.success("Exercice d'entraînement ajouté !");
//     } catch (err) {
//       console.error("Erreur lors de l'ajout :", err);
//       message.error("Erreur lors de l'ajout de l'entraînement.");
//     }
//   };

//   return (
//     <Form layout="vertical" onFinish={handleSubmit}>
//       <Form.Item
//         name="title"
//         label="Titre"
//         rules={[{ required: true, message: "Veuillez saisir un titre" }]}
//       >
//         <Input placeholder="Titre de l'exercice" />
//       </Form.Item>

//       <Form.Item label="Instructions à suivre">
//         <Editor
//           value={editorContent}
//           init={{ height: 200, menubar: false }}
//           onEditorChange={(content) => setEditorContent(content)}
//         />
//       </Form.Item>

//       <Form.Item label="Fichier à joindre">
//         <Upload
//           beforeUpload={(file) => {
//             setFile(file);
//             return false; // Empêche l'upload automatique
//           }}
//           maxCount={1}
//         >
//           <Button icon={<UploadOutlined />}>Choisir un fichier</Button>
//         </Upload>
//       </Form.Item>

//       <Form.Item>
//         <Button type="primary" htmlType="submit">
//           Enregistrer l'exercice
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// };

// export default TrainingForm;
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Upload, message, Table, Tag } from "antd";
import { UploadOutlined, FileTextOutlined, DownloadOutlined } from "@ant-design/icons";
import { Editor } from "@tinymce/tinymce-react";
import courseService from "../../services/course.service";

const TrainingForm = ({ courseId }) => {
    const [file, setFile] = useState(null);
    const [editorContent, setEditorContent] = useState("");
    const [form] = Form.useForm();

    const [trainings, setTrainings] = useState([]);
    const [gradeInputs, setGradeInputs] = useState({});
    const [loading, setLoading] = useState(false);
    const [editingExercise, setEditingExercise] = useState(null);


    const handleEdit = (record) => {
        form.setFieldsValue({ title: record.title }); // tu dois ajouter const [form] = Form.useForm();
        setEditorContent(record.instructionsText);
        setEditingExercise(record);
    };




    // const fetchTrainings = async () => {
    //     try {
    //         const data = await courseService.getTrainingExercisesByCourse(courseId);
    //         setTrainings(data);
    //     } catch (error) {
    //         console.error("Erreur lors de la récupération des entraînements:", error);
    //         message.error("Impossible de charger les exercices.");
    //     }
    // };

    const fetchTrainings = async () => {
        try {
            setLoading(true); // démarrage du chargement
            const data = await courseService.getTrainingExercisesByCourse(courseId);
            setTrainings(data);
        } catch (error) {
            console.error("Erreur lors de la récupération des entraînements:", error);
            message.error("Impossible de charger les exercices.");
        } finally {
            setLoading(false); // fin du chargement
        }
    };

   
      

    useEffect(() => {
        fetchTrainings();
    }, [courseId]);

    // const handleSubmit = async (values) => {
    //     try {
    //         if (!file) {
    //             message.warning("Veuillez sélectionner un fichier.");
    //             return;
    //         }

    //         await courseService.uploadTrainingExercise(
    //             courseId,
    //             file,
    //             values.title,
    //             editorContent
    //         );

    //         message.success("Exercice d'entraînement ajouté !");
    //         fetchTrainings();
    //     } catch (err) {
    //         console.error("Erreur lors de l'ajout :", err);
    //         message.error("Erreur lors de l'ajout de l'entraînement.");
    //     }
    // };
    const handleDelete = async (id) => {
        try {
            await courseService.deleteTrainingExercise(id);
            message.success("Exercice supprimé !");
            fetchTrainings();
        } catch (err) {
            console.error("Erreur suppression :", err);
            message.error("Erreur lors de la suppression.");
        }
    };

    const handleSubmit = async (values) => {
        try {
            if (editingExercise) {
                // 🔁 Cas de modification sans changement de fichier
                await courseService.updateExercise(
                    editingExercise.id,
                    values.title,
                    editorContent
                );
                message.success("Exercice mis à jour !");
                setEditingExercise(null);
            } else {
                if (!file) {
                    message.warning("Veuillez sélectionner un fichier.");
                    return;
                }

                await courseService.uploadTrainingExercise(
                    courseId,
                    file,
                    values.title,
                    editorContent
                );

                message.success("Exercice d'entraînement ajouté !");
            }

            fetchTrainings();
        } catch (err) {
            console.error("Erreur :", err);
            message.error("Erreur lors de l'enregistrement de l'exercice.");
        }
    };



    const columns = [
        {
            title: "Titre",
            dataIndex: "title",
            key: "title",
            render: text => <b>{text}</b>
        },
        // {
        //     title: "Note",
        //     dataIndex: "grade",
        //     key: "grade",
        //     render: grade => grade ?? <Tag color="orange">0 (par défaut)</Tag>
        // },
        {
            title: "Note",
            key: "grade",
            render: (record) => (
                <div style={{ display: "flex", gap: 8 }}>
                    <Input
                        type="number"
                        value={gradeInputs[record.id] ?? record.grade ?? 0}
                        style={{ width: 80 }}
                        onChange={(e) => {
                            const val = e.target.value;
                            setGradeInputs((prev) => ({
                                ...prev,
                                [record.id]: val
                            }));
                        }}
                    />
                    <Button
                        type="primary"
                        size="small"
                        onClick={async () => {
                            const grade = parseFloat(gradeInputs[record.id]);
                            if (!isNaN(grade)) {
                                try {
                                    await courseService.updateTrainingGrade(record.id, grade);
                                    message.success("Note mise à jour !");
                                    fetchTrainings();
                                } catch (err) {
                                    message.error("Erreur lors de la mise à jour de la note");
                                }
                            }
                        }}
                    >
                        Valider
                    </Button>
                </div>
            )
        }
        ,

        {
            title: "Fichier modèle",
            dataIndex: "templateFileUrl", // <-- CORRECTION ICI
            key: "templateFileUrl",
            render: (url) =>
                url ? (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        <DownloadOutlined /> Modèle
                    </a>
                ) : (
                    <Tag color="red">Aucun</Tag>
                )
        },
        {
            title: "Fichier étudiant",
            dataIndex: "studentFileUrl", // <-- CORRECTION ICI
            key: "studentFileUrl",
            render: (url) =>
                url ? (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        <DownloadOutlined /> Travail
                    </a>
                ) : (
                    <Tag color="gray">Non soumis</Tag>
                )
        },
        // {
        //     title: "Action",
        //     key: "action",
        //     render: (_, record) => (
        //       <Button
        //         danger
        //         onClick={async () => {
        //           try {
        //             await courseService.deleteTrainingExercise(record.id);
        //             message.success("Exercice supprimé !");
        //             fetchTrainings();
        //           } catch (err) {
        //             message.error("Erreur lors de la suppression.");
        //           }
        //         }}
        //       >
        //         Supprimer
        //       </Button>
        //     )
        //   }
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <>
                    {/* <Button danger onClick={() => handleDelete(record.id)}>Supprimer</Button> */}
                    <Button danger onClick={() => handleDelete(record.id)}>Supprimer</Button>

                    <Button type="link" onClick={() => handleEdit(record)}>Modifier</Button>
                </>
            )
        }



    ];

    return (
        <>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item
                    name="title"
                    label="Titre"
                    rules={[{ required: true, message: "Veuillez saisir un titre" }]}
                >
                    <Input placeholder="Titre de l'exercice" />
                </Form.Item>

                <Form.Item label="Instructions à suivre">
                    <Editor
                        value={editorContent}
                        init={{ height: 200, menubar: false }}
                        onEditorChange={(content) => setEditorContent(content)}
                    />
                </Form.Item>

                <Form.Item label="Fichier à joindre">
                    <Upload
                        beforeUpload={(file) => {
                            setFile(file);
                            return false;
                        }}
                        maxCount={1}
                    >
                        <Button icon={<UploadOutlined />}>Choisir un fichier</Button>
                    </Upload>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Enregistrer l'exercice
                    </Button>
                </Form.Item>
            </Form>

            <h3>📋 Liste des exercices pour ce cours</h3>
            <Table
                dataSource={trainings}
                columns={columns}
                rowKey="id"
                loading={loading} // ici le spinner s'affiche automatiquement
                bordered
                pagination={{ pageSize: 5 }}
            />
        </>
    );
};

export default TrainingForm;
